import { useEffect, useState } from 'react'
import { X, Pause, Loader2 } from 'lucide-react'
import toast from 'react-hot-toast'
import { kioskApi } from './kiosk-api'

type Motivo = { id: number; codigo: string; nome: string; categoria: string; cor: string | null }

export default function KioskPausa({ etapa_op_id, onClose, onDone }: {
  etapa_op_id: number; onClose: () => void; onDone: () => void
}) {
  const [motivos, setMotivos] = useState<Motivo[]>([])
  const [motivoId, setMotivoId] = useState<number | null>(null)
  const [obs, setObs] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    kioskApi.get<Motivo[]>('/kiosk/motivos-parada').then(r => setMotivos(r.data))
  }, [])

  async function submit() {
    if (!motivoId) return
    setLoading(true)
    try {
      await kioskApi.post('/kiosk/pausa', {
        etapa_op_id, motivo_parada_id: motivoId,
        observacao: obs || undefined,
      })
      toast.success('Etapa pausada')
      onDone()
    } catch (e: any) {
      toast.error(e?.response?.data?.detail || 'Erro')
    } finally { setLoading(false) }
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-end md:items-center justify-center">
      <div className="bg-white w-full md:max-w-lg rounded-t-2xl md:rounded-2xl p-5 space-y-4 max-h-[95vh] overflow-y-auto">
        <div className="flex items-start justify-between">
          <h2 className="text-xl font-bold flex items-center gap-2">
            <Pause className="h-5 w-5 text-amber-600" /> Pausar etapa
          </h2>
          <button onClick={onClose}><X className="h-6 w-6" /></button>
        </div>

        <div>
          <div className="text-xs uppercase text-ink-500 font-semibold mb-2">Motivo</div>
          <div className="grid grid-cols-2 gap-2">
            {motivos.map(m => (
              <button
                key={m.id}
                onClick={() => setMotivoId(m.id)}
                className={`p-3 rounded-xl text-left text-sm font-medium border-2 transition ${
                  motivoId === m.id ? 'border-amber-500 bg-amber-50' : 'border-ink-200 hover:border-ink-300'
                }`}
                style={motivoId === m.id && m.cor ? { borderColor: m.cor, backgroundColor: m.cor + '15' } : {}}
              >
                {m.nome}
                <div className="text-xs text-ink-500 mt-0.5">{m.categoria}</div>
              </button>
            ))}
          </div>
        </div>

        <input
          value={obs}
          onChange={(e) => setObs(e.target.value)}
          placeholder="Observação (opcional)"
          className="w-full h-12 px-4 border-2 border-ink-200 rounded-xl"
        />

        <button
          onClick={submit}
          disabled={!motivoId || loading}
          className="w-full h-16 bg-amber-500 hover:bg-amber-600 text-white font-bold text-lg rounded-xl flex items-center justify-center gap-2 disabled:opacity-40"
        >
          {loading ? <Loader2 className="h-6 w-6 animate-spin" /> : 'Pausar'}
        </button>
      </div>
    </div>
  )
}
